import React from 'react';

interface SettingsIconProps {
  size?: number;
  color?: string;
}

export const SettingsIcon: React.FC<SettingsIconProps> = ({ 
  size = 20, 
  color = '#fff' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 20 20"
    >
      <g clipPath="url(#aSettingsIcon)">
        <path 
          fill={color} 
          d="M10 3.125A4.35 4.35 0 0 0 5.625 7.5a4.35 4.35 0 0 0 1.919 3.633c-2.225.958-3.794 3.175-3.794 5.742H5c0-2.75 2.25-5 5-5A4.35 4.35 0 0 0 14.375 7.5 4.35 4.35 0 0 0 10 3.125m0 1.25A3.095 3.095 0 0 1 13.125 7.5 3.095 3.095 0 0 1 10 10.625 3.095 3.095 0 0 1 6.875 7.5 3.095 3.095 0 0 1 10 4.375m5.063 6.875v1.313c-.376.062-.75.25-1.063.437l-.937-.937-.876.874.938.938c-.25.313-.375.688-.437 1.125H11.25v1.25h1.313c.062.375.25.75.437 1.125l-.937.938.874.875.938-.938c.313.188.688.375 1.063.438V20h1.25v-1.312c.375-.063.75-.25 1.062-.438l.938.938.875-.875-.938-.938c.25-.312.375-.687.438-1.125H20V15h-1.312c-.063-.375-.25-.75-.438-1.125l.938-.937-.875-.876-.938.938c-.312-.187-.687-.375-1.062-.437V11.25zm.562 2.5c1.063 0 1.875.813 1.875 1.875a1.84 1.84 0 0 1-1.875 1.875 1.84 1.84 0 0 1-1.875-1.875c0-1.062.813-1.875 1.875-1.875m0 1.25a.6.6 0 0 0-.23.054.7.7 0 0 0-.2.142.7.7 0 0 0-.141.2.6.6 0 0 0-.054.229c0 .234.176.469.396.571a.6.6 0 0 0 .229.054c.313 0 .625-.312.625-.625 0-.312-.312-.625-.625-.625"
        />
      </g>
      <defs>
        <clipPath id="aSettingsIcon">
          <path fill="#fff" d="M0 0h20v20H0z"/>
        </clipPath>
      </defs>
    </svg>
  );
};


